module.exports = __webpack_public_path__ + "img/blockchain.8a08af64.png";